import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// Configure axios defaults
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:5000/api'
axios.defaults.withCredentials = true // Enable sending cookies with requests

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config
    const isLoginPage = router.currentRoute.value.path === '/login'
    const isRegisterPage = router.currentRoute.value.path === '/register'
    const isResetPasswordPage = router.currentRoute.value.path === '/reset-password'
    const isAuthCheck = originalRequest.url === '/auth/check-auth'

    // Don't try to refresh token if we're on login/register/reset-password pages or if this is an auth check
    if (isLoginPage || isRegisterPage || isResetPasswordPage || isAuthCheck) {
      return Promise.reject(error)
    }

    // If the error is 401 (Unauthorized) and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // Try to refresh the token - the refresh token is sent automatically in cookies
        await axios.post('/auth/refresh')

        // Retry the original request
        return axios(originalRequest)
      } catch (refreshError) {
        // If refresh fails, redirect to login only if not already on login page
        if (!isLoginPage) {
          router.push('/login')
        }
        return Promise.reject(refreshError)
      }
    }

    // For 403 (Forbidden) errors, just redirect to login if not already on login page
    if (error.response?.status === 403 && !isLoginPage) {
      router.push('/login')
    }

    return Promise.reject(error)
  }
)

createApp(App).use(store).use(router).mount('#app')